import {
  File,
  FileAudio2,
  FileImageIcon,
  FileJson,
  FilePieChart,
  FileSpreadsheet,
  FileText,
  FileVideo,
  FolderArchive,
  FolderIcon,
} from "lucide-react"

// ** Helpers
import { cn } from "@pma/utils/helpers"

// ** Types
import { FileIconProps } from "@pma/types"
import { AUDIO_EXTENSIONS, VIDEO_EXTENSIONS } from "@pma/utils/constants"

const IMAGE_EXTENSIONS = [
  "jpg", "jpeg", "jpe", "jif", "jfif", "jfi", "png", "webp", "gif",
  "bmp", "dib", "tif", "tiff", "heif", "heic", "ico", "cur", "svg",
  "svgz", "avif", "apng", "raw", "arw", "cr2", "nrw", "k25", "log",
]
const FILE_EXTENSIONS = ["dwg", "ifc", "txt"]
const DOCUMENT_EXTENSIONS = ["doc", "docx"]
const SHEET_EXTENSIONS = ["xlsx", "xls", "csv"]
const PRESENTATION_EXTENSIONS = ["pptx", "ppt"]
const JSON_EXTENSIONS = ["json"]
const PDF_EXTENSIONS = ["pdf"]
const ZIP_EXTENSIONS = ["zip", "rar", "7z"]

export default function RenderFileIcon({ type, size, styleClass }: FileIconProps) {
  const fileType = type?.toLocaleLowerCase()
  const baseClass = cn("h-5 w-5", size === "lg" && "h-20 w-20", styleClass)

  if (IMAGE_EXTENSIONS.includes(fileType)) {
    return <FileImageIcon className={cn(baseClass, "text-green-500")} />
  }
  if (VIDEO_EXTENSIONS.includes(fileType)) {
    return <FileVideo className={cn(baseClass, "text-red-500")} />
  }
  if (AUDIO_EXTENSIONS.includes(fileType)) {
    return <FileAudio2 className={cn(baseClass, "text-purple-500")} />
  }
  if (DOCUMENT_EXTENSIONS.includes(fileType)) {
    return <FileText className={cn(baseClass, "text-primary")} />
  }
  if (SHEET_EXTENSIONS.includes(fileType)) {
    return <FileSpreadsheet className={cn(baseClass, "text-green-700")} />
  }
  if (PRESENTATION_EXTENSIONS.includes(fileType)) {
    return <FilePieChart className={cn(baseClass, "text-orange-500")} />
  }
  if (FILE_EXTENSIONS.includes(fileType)) {
    return <File className={cn(baseClass, "text-slate-500")} />
  }
  if (JSON_EXTENSIONS.includes(fileType)) {
    return <FileJson className={cn(baseClass, "text-yellow-500")} />
  }
  if (PDF_EXTENSIONS.includes(fileType)) {
    return (
      <img
        src={`${process.env.PUBLIC_URL}/pdf.svg`}
        className={cn("h-5 w-5", size === "lg" && "h-20 w-20", styleClass)}
        alt="PDF"
      />
    )
  }
  if (ZIP_EXTENSIONS.includes(fileType)) {
    return <FolderArchive className={cn(baseClass, "text-gray-500")} />
  }
  return <FolderIcon className={cn(baseClass, "text-gray-500")} />
}